<template>
  <Swiper
    :modules="modules"
    :slides-per-view="1.2"
    :breakpoints="{
      420: {
        slidesPerView: 2.2
      },
      760: {
        slidesPerView: 3.2
      }
    }"
    :space-between="16"
    :grab-cursor="true"
    :speed="600"
    :class="$style.swiper"
  >
    <SwiperSlide v-for="(item, idx) in data" :key="idx">
      <FooterMenuListItem :data="item" />
    </SwiperSlide>
  </Swiper>
</template>

<script setup lang="ts">
import { Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/css'

defineProps<{
  data: FooterMenuItemRecord[]
}>()

const modules = [Parallax, A11y]
</script>

<style lang="postcss" module>
.swiper {
  @apply relative mx-auto h-auto w-full px-4;
}
</style>
